import { BackofficeARIDTO, DailySet } from "../types";
import { StaticComplementData } from "../../../../gen/witbooking/ari/v1/static_ari_pb";

const getDailySet = (startDate: string, endDate: string, dailySet: DailySet[], ticker: string): DailySet[] => {
  if (!dailySet) {
    return [{ startDate, endDate, value: 0 }];
  }

  if (dailySet.length === 0) {
    throw new Error(`Complement daily set with ticker [${ticker}] is empty probably because it shares its ticker with other bookable`);
  }

  // Set end date because complements come without the request's end date
  const result = [...dailySet];
  result[dailySet.length - 1].endDate = endDate;
  return result;
}

export class ComplementData {
  ticker: string;
  dailySet: DailySet[];

  constructor(ticker: string, dailySet: DailySet[]) {
    this.ticker = ticker;
    this.dailySet = dailySet;
  }

  static of(
    backofficeAriDto: BackofficeARIDTO,
    staticComplementData: StaticComplementData.AsObject[],
    startDate: string,
    endDate: string
  ): ComplementData[] {
    return staticComplementData
      .filter(({ bucketConfig }) =>
        bucketConfig?.rate && !bucketConfig?.rate.parentTicker && !bucketConfig?.rate.constant
      )
      .map(it => new ComplementData(
        it.ticker,
        getDailySet(startDate, endDate, backofficeAriDto[it.ticker]?.rate?.dailySet, it.ticker)
      ));
  }
}